import React from "react";
import { UserDataContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { CONSUMER_ROUTE_PATH } from "utils/constants/routePath";
import { consumerService } from "apiServices";
import moment from "moment";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import { RenderSortTable } from "utils/functions/SortTable";
import * as XLSX from "xlsx";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { toast } from "react-toastify";
import {
  Tables,
  Icons,
  Inputs,
  Typhographys,
  Displays,
  Buttons,
} from "components";
import {
  parseFilterFromSearchParams,
  buildApiQueryString,
  mergeFilterIntoParams,
  legacyQueryStringToObject,
  clearFilterParams,
} from "utils/functions/filterUrl";

class UserDataContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    isLoadingTable: true,
    sortTable: {
      firstname: 1,
      lastname: 1,
      phone_number: 1,
      province: 1,
      created_at: 1,
      created_at_time: 1,
      prize_wheel_quota: 1,
    },
  };

  componentDidMount() {
    scrollToTopPageFN();
    const { searchParams, setSearchParams } = this.props.router;
    if (!searchParams.get("limit")) {
      const sp = new URLSearchParams(searchParams);
      if (!sp.get("limit")) sp.set("limit", "10");
      if (!sp.get("page")) sp.set("page", "1");
      setSearchParams(sp, { replace: true });
      this.fetchData(buildApiQueryString(sp));
    } else {
      this.fetchData(buildApiQueryString(searchParams));
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.router.location.search !== this.props.router.location.search
    ) {
      this.setState({ isLoadingTable: true });
      this.fetchData(buildApiQueryString(this.props.router.searchParams));
    }
  }

  fetchData = async (stringQuery) => {
    let res = await consumerService.GET_CONSUMER_BY_POINT_LIST(stringQuery);
    if (res && res.status === 200) {
      const docs = Array.isArray(res.data) ? res.data : res.data?.docs || [];
      const pag = res.data?.pagination || res.pagination || {};
      this.setState({
        data: docs,
        pagination: {
          last_page: pag.pages || 1,
          current_page: Number(pag.page) || 1,
        },
        isLoading: false,
        isLoadingTable: false,
      });
    } else {
      this.setState({ isLoading: false, isLoadingTable: false });
    }
  };

  handlePageClick = (e) => {
    const sp = new URLSearchParams(this.props.router.searchParams);
    sp.set("page", String(e.selected + 1));
    this.props.router.setSearchParams(sp);
  };

  handleFilterKeyword = (legacyQs) => {
    const patch = legacyQueryStringToObject(legacyQs);
    const sp = mergeFilterIntoParams(this.props.router.searchParams, patch, {
      resetPage: true,
    });
    this.props.router.setSearchParams(sp);
  };

  handleSelectedPerPage = (limit) => {
    const sp = new URLSearchParams(this.props.router.searchParams);
    sp.set("limit", String(limit));
    sp.set("page", "1");
    this.props.router.setSearchParams(sp);
  };

  handleClearFilter = () => {
    const sp = clearFilterParams(this.props.router.searchParams, dataFilter2);
    this.props.router.setSearchParams(sp);
  };

  handleClickItem = (e) => {
    this.props.router.navigate(`${CONSUMER_ROUTE_PATH.USER_DATA}/${e}`);
  };

  handleSort = (e) => {
    const { data, sortTable } = this.state;
    if (data && data.length > 0) {
      let sortValue;
      switch (e) {
        case "firstname":
          sortValue = RenderSortTable(e, data, sortTable.firstname);
          this.setState({
            data: sortValue.data,
            sortTable: {
              ...sortTable,
              firstname: sortValue.sortNumber,
            },
          });
          break;

        case "lastname":
          sortValue = RenderSortTable(e, data, sortTable.lastname);
          this.setState({
            data: sortValue.data,
            sortTable: {
              ...sortTable,
              lastname: sortValue.sortNumber,
            },
          });
          break;

        case "phone_number":
          sortValue = RenderSortTable(e, data, sortTable.phone_number);
          this.setState({
            data: sortValue.data,
            sortTable: {
              ...sortTable,
              phone_number: sortValue.sortNumber,
            },
          });
          break;

        case "province_only":
          sortValue = RenderSortTable(e, data, sortTable.province);
          this.setState({
            data: sortValue.data,
            sortTable: {
              ...sortTable,
              province: sortValue.sortNumber,
            },
          });
          break;

        case "prize_wheel_quota":
          sortValue = RenderSortTable(e, data, sortTable.prize_wheel_quota);
          this.setState({
            data: sortValue.data,
            sortTable: {
              ...sortTable,
              prize_wheel_quota: sortValue.sortNumber,
            },
          });
          break;

        case "created_at":
          sortValue = RenderSortTable(e, data, sortTable.created_at);
          this.setState({
            data: sortValue.data,
            sortTable: {
              ...sortTable,
              created_at: sortValue.sortNumber,
            },
          });
          break;

        case "created_at_time":
          sortValue = RenderSortTable(e, data, sortTable.created_at_time);
          this.setState({
            data: sortValue.data,
            sortTable: {
              ...sortTable,
              created_at_time: sortValue.sortNumber,
            },
          });
          break;

        default:
          break;
      }
    }
  };

  handleDownloadExcel = async () => {
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = buildApiQueryString(this.props.router.searchParams, {
      includePagination: false,
    });
    let res = await consumerService.GET_CONSUMER_BY_POINT_LIST(joinQuery);
    if (res && res.status === 200) {
      var wb = XLSX.utils.book_new();
      var ws_name = "SheetJS";
      /* make worksheet */
      var ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          e.firstname,
          e.lastname,
          e.phone_number,
          e.province,
          e.district,
          e.sub_district,
          RenderCommaMoney(Number(e.wheel_game_quota_before_reset), true),
          RenderCommaMoney(Number(e.wheel_game_quota), true),
          RenderCommaMoney(Number(e.last_2_months.net_points), true),
          RenderCommaMoney(Number(e.last_1_month.net_points), true),
          RenderCommaMoney(Number(e.current_month.net_points), true),
          moment(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY"),
          moment(e.created_at).tz("Asia/Bangkok").format("HH:mm"),
          moment(e.updated_at).tz("Asia/Bangkok").format("DD/MM/YYYY"),
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        "No",
        "ชื่อ",
        "นามสกุล",
        "เบอร์โทร",
        "จังหวัด",
        "ตำบล",
        "อำเภอ",
        "แต้มจนถึง 30/6/2025",
        "แต้มสะสมคงเหลือ",
        "แต้มที่สะสมได้เดือนย้อนหลัง 2",
        "แต้มที่สะสมได้เดือนย้อนหลัง 1",
        "แต้มที่สะสมได้เดือนปัจจุบัน",
        "วันที่ลงทะเบียน",
        "เวลา",
        "วันที่อัพเดตข้อมูล",
      ]);
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wscols = [
        { wch: 5 },
        { wch: 25 },
        { wch: 25 },
        { wch: 20 },
        { wch: 25 },
        { wch: 15 },
        { wch: 17 },
        { wch: 17 },
        { wch: 17 },
      ];
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `Consumer report ${moment()
          .tz("Asia/Bangkok")
          .format("DD/MM/YYYY")}.xlsx`,
      );
      this.setState({
        isBgLoading: false,
      });
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error("download fail");
    }
  };

  render() {
    const { isLoading, isBgLoading, data, pagination, isLoadingTable } =
      this.state;
    const { searchParams } = this.props.router;
    const { filterValues, limit } = parseFilterFromSearchParams(
      searchParams,
      dataFilter2,
      { defaultLimit: 10 },
    );
    return (
      <UserDataContainerStyled>
        <Displays.BgLoading visible={isBgLoading} />
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading />
          </div>
        ) : (
          <>
            <div className="title_show">
              <Typhographys.HeaderH1 label="Consumer data" />
            </div>
            <div className="filter_wrap">
              <Inputs.InputFilter
                theme_standard_input_filter
                dataFilter={dataFilter2}
                btnLabel="ค้นหา"
                initialValues={filterValues}
                onQueryFilter={this.handleFilterKeyword}
                onClear={this.handleClearFilter}
              />
            </div>
            <div className="export_zone">
              <Inputs.InputDropDownFilter
                placeholder="เลือก"
                value={String(limit)}
                iconSvgClose={<Icons.ArrowDropDown />}
                iconSvgOpen={<Icons.ArrowDropDown up />}
                onChange={this.handleSelectedPerPage}
                options={[
                  { label: "แสดง 10 แถว", value: "10" },
                  { label: "แสดง 20 แถว", value: "20" },
                  { label: "แสดง 30 แถว", value: "30" },
                  { label: "แสดง 40 แถว", value: "40" },
                  { label: "แสดง 50 แถว", value: "50" },
                ]}
              />
              <div className="btnw">
                <Buttons.BtnNormal
                  theme_normal_btn
                  label="Export"
                  onClick={this.handleDownloadExcel}
                />
              </div>
            </div>
            <Tables.TableNormal
              theme_standard_table_normal
              showPagination
              useNo
              // useRenderNoPage
              data={data || []}
              isLoading={isLoadingTable}
              pagination={pagination}
              handlePageClick={this.handlePageClick}
              limit={limit}
              columns={columns3({
                onClickItem: this.handleClickItem,
                onSort: this.handleSort,
              })}
            />
          </>
        )}
      </UserDataContainerStyled>
    );
  }
}

const dataFilter2 = [
  {
    accessor: "firstname",
    length: "260px",
    filter: {
      fieldQuery: "firstname",
      type: "text",
      placeholder: "ค้นหาชื่อ",
    },
  },
  {
    accessor: "lastname",
    length: "260px",
    filter: {
      fieldQuery: "lastname",
      type: "text",
      placeholder: "ค้นหานามสกุล",
    },
  },
  {
    accessor: "phone_number",
    length: "260px",
    filter: {
      fieldQuery: "phone_number",
      type: "text",
      placeholder: "ค้นหาเบอร์โทร",
    },
  },
];

const columns3 = ({ onClickItem, onSort }) => [
  {
    title: "ลำดับ",
    field: "no",
    headerStyle: { textAlign: "center", width: "50px", flexShrink: 0 },
    style: { textAlign: "center", width: "50px", flexShrink: 0 },
  },
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        ชื่อ
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("firstname")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "firstname",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => (
      <div
        style={{ textDecoration: "underline" }}
        onClick={() => onClickItem(origin._id)}
      >
        {value}
      </div>
    ),
  },
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        นามสกุล
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("lastname")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "lastname",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => <div>{value}</div>,
  },
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        เบอร์โทร
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("phone_number")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "phone_number",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => <div>{value}</div>,
  },
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        จังหวัด
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("province_only")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "province",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => <div>{value}</div>,
  },

  {
    title: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          opacity: 0.6,
        }}
      >
        แต้มจนถึง 30/6/2025
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("wheel_game_quota_before_reset")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "wheel_game_quota_before_reset",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => (
      <div>{RenderCommaMoney(Number(value), true)}</div>
    ),
  },
  {
    title: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          opacity: 0.6,
        }}
      >
        แต้มเคลื่อนไหวย้อนหลัง 2 เดือน
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("last_2_months.net_points")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "last_2_months.net_points",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => (
      <div>{RenderCommaMoney(Number(value), true)}</div>
    ),
  },
  {
    title: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          opacity: 0.6,
        }}
      >
        แต้มเคลื่อนไหวย้อนหลัง 1 เดือน
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("last_1_month.net_points")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "last_1_month.net_points",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => (
      <div>{RenderCommaMoney(Number(value), true)}</div>
    ),
  },
  {
    title: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          opacity: 0.6,
        }}
      >
        แต้มที่สะสมได้เดือนปัจจุบัน
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("current_month.net_points")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "current_month.net_points",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => (
      <div>{RenderCommaMoney(Number(value), true)}</div>
    ),
  },
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        แต้มสะสมคงเหลือ
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("wheel_game_quota")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "wheel_game_quota",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => (
      <div>{RenderCommaMoney(Number(value), true)}</div>
    ),
  },
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        วันที่ลงทะเบียน
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("created_at")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "created_at",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => (
      <div>{moment(value).format("DD/MM/YYYY")}</div>
    ),
  },
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        เวลา
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("created_at_time")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "created_at_time",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => (
      <div>{moment(origin.created_at).tz("Asia/Bangkok").format("HH:mm")}</div>
    ),
  },
  {
    title: (
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        วันที่อัพเดตข้อมูล
        <div
          style={{ marginLeft: "8px", display: "flex" }}
          onClick={() => onSort("updated_at")}
        >
          <Icons.ArrowSort />
        </div>
      </div>
    ),
    field: "updated_at",
    headerStyle: { textAlign: "left" },
    style: { textAlign: "left" },
    render: ({ origin, value }) => (
      <div>{moment(value).format("DD/MM/YYYY")}</div>
    ),
  },
];

export default withRouter(UserDataContainer);
